import { render, staticRenderFns } from "./group-permissions-users.vue?vue&type=template&id=8d3ee83e&"
import script from "./group-permissions-users.vue?vue&type=script&lang=js&"
export * from "./group-permissions-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports